

<template>
    <div>
        <Breadcrumb class="tablelist-header" v-if="!activeids">
            <BreadcrumbItem
                >{{ title[type]
                }}{{
                    $t("erp.b2c.b2c_order", { defaultValue: "B2C订单" })
                }}</BreadcrumbItem
            >
        </Breadcrumb>
        <Steps
            :current="statusIndex"
            class="bg-fff padding-20"
            v-if="type === 'query'"
        >
            <Step
                v-for="(val, key) of progressStatus"
                :title="val.name"
                :key="key"
            ></Step>
        </Steps>
        <div class="bg-fff padding-bottom-10" v-if="type == 'query'">
            <Form inline class="search-other">
                <Button
                    class="margin-right-5 dark-primary"
                    v-if="
                        dataBaseInfo.fulfillmentChannel == 'MFN' &&
                        (statusIndex == 2 ||
                            statusIndex == 3 ||
                            statusIndex == 4)
                    "
                    @click="handleOperate('reset')"
                    >{{
                        $t("erp.b2c.reset_order", { defaultValue: "重置订单" })
                    }}</Button
                >

                <Button
                    class="margin-right-5"
                    type="info"
                    v-if="dataBaseInfo.isActive === 'N'"
                    @click="handleOperate('activeorder')"
                    >{{
                        $t("erp.b2c.active_order", { defaultValue: "激活订单" })
                    }}</Button
                >

                <!-- <Button class="margin-right-5" type="success"  @click="handleOperate('project')">项目手动关联</Button> -->
                <!-- <Button class="margin-right-5" type="info" v-if="dataBaseInfo.fulfillmentChannel=='MFN' && (statusIndex==2||statusIndex==3||statusIndex==4 || statusIndex==5) && nodeid==0 && SYSID!=1000025" @click="handleOperate('addproduct')">{{$t('erp.b2c.add_giftorder',{defaultValue:'添加礼品订单'})}}</Button> -->

                <Button
                    class="margin-right-5 light-content"
                    @click="handleOperate('addnotes')"
                    >{{
                        $t("erp.b2c.add_notes", { defaultValue: "添加备注" })
                    }}</Button
                >

                <!--<Button class="margin-right-5 light-primary" v-if="dataBaseInfo.fulfillmentChannel=='MFN' && (statusIndex==3||statusIndex==4||statusIndex==5) && SYSID!=1000025" @click="handleOperate('manualback')">{{$t('erp.b2c.manual_back',{defaultValue:'手动回传'})}}</Button>-->

                <!-- <Button class="margin-right-5 light-purple" v-if="dataBaseInfo.fulfillmentChannel=='MFN' && (statusIndex==1||statusIndex==2||statusIndex==3||statusIndex==5) && SYSID==1" @click="handleOperate('forcemanualback')">{{$t('erp.b2c.mandatorymanual_back',{defaultValue:'平台回传'})}}</Button> -->

                <Button
                    class="margin-right-5 light-purple"
                    v-if="
                        dataBaseInfo.fulfillmentChannel == 'MFN' &&
                        (statusIndex == 1 ||
                            statusIndex == 2 ||
                            statusIndex == 3 ||
                            statusIndex == 4 ||
                            statusIndex == 5) && b2cOrderset
                    "
                    @click="handleOperate('forcemanualback')"
                    >{{
                        $t("erp.b2c.mandatorymanual_back", {
                            defaultValue: "平台回传",
                        })
                    }}</Button
                >

                <Button
                    class="margin-right-5 middle-content"
                    v-if="
                        dataBaseInfo.fulfillmentChannel == 'MFN' &&
                        (statusIndex == 1 ||
                            statusIndex == 2 ||
                            statusIndex == 3 ||
                            statusIndex == 4 ||
                            statusIndex == 5) &&
                        SYSID != 1000025 && b2cOrderset
                    "
                    @click="handleOperate('attacheupload')"
                    >{{
                        $t("erp.b2c.arrachement_upload", {
                            defaultValue: "附件上传",
                        })
                    }}</Button
                >

                <Button
                    class="margin-right-5"
                    type="warning"
                    v-if="dataBaseInfo.errorCode != 'unexception'"
                    @click="handleOperate('normal')"
                    >{{
                        $t("erp.b2c.back_normal", { defaultValue: "恢复正常" })
                    }}</Button
                >

                <!-- <Button
                    class="margin-right-5 light-primary"
                    v-if="dataBaseInfo.errorCode != 'unexception'"
                    @click="handleOperate('removeexcept')"
                    >{{
                        $t("erp.b2c.back_normal_onlyremove", {
                            defaultValue: "恢复正常(仅去除异常)",
                        })
                    }}
                </Button> -->

                <Button
                    class="margin-right-5"
                    type="success"
                    v-if="
                        dataBaseInfo.errorCode == 'unexception' &&
                        dataBaseInfo.fulfillmentChannel == 'MFN' &&
                        statusIndex != 6 && b2cOrderresubmit
                    "
                    @click="handleOperate('resubmit')"
                    >{{
                        $t("global.common.resubmit", {
                            defaultValue: "重新提交",
                        })
                    }}</Button
                >
                <Tooltip
                    max-width="230"
                    placement="bottom"
                    :content="
                        $t('erp.b2c.one_click_split_order_hover_tip', {
                            defaultValue:
                                '按仓库+项目拆单，无库存自动分配到Scott_MI_US(工厂虚拟仓(美国))，拆解后的配货单为已创建状态，需要手动激活订单',
                        })
                    "
                >
                    <Button
                        class="margin-right-5"
                        type="success"
                        v-if="
                            dataBaseInfo.fulfillmentChannel == 'MFN' &&
                            (statusIndex == 1 || statusIndex == 2) &&
                            SYSID == 1
                        "
                        @click="handleOperate('orderDistributionDisassembly')"
                        >{{
                            $t("erp.b2c.one_click_split_order", {
                                defaultValue: "一键拆单",
                            })
                        }}</Button
                    >
                </Tooltip>

                <Button
                    class="margin-right-5"
                    type="warning"
                    v-if="
                        dataBaseInfo.fulfillmentChannel == 'MFN' &&
                        (dataBaseInfo.orderStatus == 'pending' ||
                            dataBaseInfo.orderStatus == 'unshipped' ||
                            dataBaseInfo.orderStatus == 'approved')&& b2cOrderset
                    "
                    @click="handleOperate('edit')"
                    >{{
                        $t("global.common.operation_edit", {
                            defaultValue: "编辑",
                        })
                    }}</Button
                >

                <Button
                    class="margin-right-5 light-content"
                    v-if="
                        dataBaseInfo.isArtificial === 'Y'&& b2cOrderset
                    "
                    @click="handleOperate('passapprove')"
                    >{{
                        $t("erp.b2c.approved", { defaultValue: "审核通过" })
                    }}</Button
                >
                <!-- <Button v-if="changekeys=='' || changekeys=='EQ_isArtificial'" class="margin-right-5 light-content" @click="handleModal('passapprove')">{{$t('erp.b2c.approved',{defaultValue:'审核通过'})}}</Button> -->

                <Dropdown v-if="b2cOrderset" trigger="hover" @on-click="handleModal">
                    <Button type="error">
                        {{
                            $t("global.common.operates", {
                                defaultValue: "更多操作",
                            })
                        }}
                        <Icon type="md-arrow-dropdown" />
                    </Button>
                    <DropdownMenu slot="list">
                        <!-- <DropdownItem name="removeexcept"> -->
                        <DropdownItem v-if="dataBaseInfo.errorCode != 'unexception'" name="removeexcept">
                            {{
                                $t("erp.b2c.back_normal_onlyremove", {
                                    defaultValue: "恢复正常(仅去除异常)",
                                })
                            }}
                        </DropdownItem>
                        <Dropdown placement="right-start">
                            <DropdownItem>
                                {{
                                    $t("erp.b2c.modify_order", {
                                        defaultValue: "修改订单类型",
                                    })
                                }}
                                <Icon type="ios-arrow-right"></Icon>
                            </DropdownItem>
                            <DropdownMenu slot="list">
                                <DropdownItem name="normalsales">{{
                                    $t("erp.b2c.ordertype_normally", {
                                        defaultValue: "正常销售",
                                    })
                                }}</DropdownItem>
                                <DropdownItem name="displayorder">{{
                                    $t("erp.b2c.ordertype_celebrity", {
                                        defaultValue: "展示订单",
                                    })
                                }}</DropdownItem>
                                <DropdownItem name="distributeorder">{{
                                    $t("erp.b2c.ordertype_distribution", {
                                        defaultValue: "分销订单",
                                    })
                                }}</DropdownItem>
                                <DropdownItem name="revieworder">{{
                                    $t("erp.b2c.ordertype_brush", {
                                        defaultValue: "刷评订单",
                                    })
                                }}</DropdownItem>
                                <DropdownItem name="deliveryOrder">{{
                                    $t("erp.b2c.ordertype_delivery", {
                                        defaultValue: "发货订单",
                                    })
                                }}</DropdownItem>
                            </DropdownMenu>
                        </Dropdown>
                        <Dropdown placement="right-start">
                            <DropdownItem>
                                {{
                                    $t("erp.b2c.addorder_mark", {
                                        defaultValue: "增加订单标记",
                                    })
                                }}
                                <Icon type="ios-arrow-right"></Icon>
                            </DropdownItem>
                            <DropdownMenu slot="list">
                                <DropdownItem name="reissueorder">{{
                                    $t("erp.b2c.replacement_order", {
                                        defaultValue: "补发订单",
                                    })
                                }}</DropdownItem>
                                <DropdownItem name="redpeopleorder">{{
                                    $t("erp.b2c.redpeople_order", {
                                        defaultValue: "红人订单",
                                    })
                                }}</DropdownItem>
                                <DropdownItem name="sampleorder">{{
                                    $t("erp.b2c.sample_order", {
                                        defaultValue: "样品订单",
                                    })
                                }}</DropdownItem>
                            </DropdownMenu>
                        </Dropdown>
                        <DropdownItem name="submitabnormal">{{
                            $t("erp.b2c.submit_abnormal", {
                                defaultValue: "提交异常",
                            })
                        }}</DropdownItem>
                        <!--<DropdownItem name="handerclose">{{$t('erp.b2c.manual_override',{defaultValue:'手动关闭'})}}</DropdownItem>-->
                        <DropdownItem
                            v-if="
                                (dataBaseInfo.isArtificial === 'Y' &&
                                    dataBaseInfo.orderStatus === 'unshipped') ||
                                dataBaseInfo.orderStatus === 'approved'
                            "
                            name="changesendtime"
                            >{{
                                $t(
                                    "erp.distribution.change_lastest_send_time",
                                    {
                                        defaultValue: "修改最晚发货时间",
                                    }
                                )
                            }}</DropdownItem
                        >
                        <DropdownItem name="loadcost">{{
                            $t("erp.b2c.acquirecost", {
                                defaultValue: "成本获取",
                            })
                        }}</DropdownItem>
                        <DropdownItem name="downorder">{{
                            $t("erp.b2c.download_expressbill", {
                                defaultValue: "下载面单",
                            })
                        }}</DropdownItem>
                        <compLabelSelect
                            :dataList="labelList"
                            :modalProps="{ title: $t('erp.b2corder.label_label_font', { defaultValue: '标签' })}"
                            style="width: 100%;" 
                            :buttonStyle="`width: 100%; border: none; text-align: left;`"
                            :needRefresh="true"
                            :selected="selectedList"
                            @on-confirm-change="handleLabelChange"
                            type="default">
                            {{$t('erp.b2corder.label_label_font', { defaultValue: '标签' })}}
                        </compLabelSelect>
                    </DropdownMenu>
                </Dropdown>

                <Button
                    type="primary"
                    class="width-10per pull-right"
                    @click="refresh"
                    >{{
                        $t("global.common.refresh", { defaultValue: "刷新" })
                    }}</Button
                >
            </Form>
        </div>
        <div
            v-if="
                dataBaseInfo.errorCode != 'unexception' &&
                type == 'query' &&
                loading == false
            "
            class="errorCodebox"
        >
            {{ $t("erp.b2c.abnormal_order", { defaultValue: "异常订单" }) }}:{{
                filterCode(dataBaseInfo.errorCode)
            }}
        </div>
        <!-- 查看 -->
        <compBase
            :combaseInfo="dataBaseInfo"
            :labelData="labelList"
            :selectedLabel="selectedList"
            ref="refbase"
            class="b2corder"
        ></compBase>
        <!-- 关联配货单 -->
        <compDistribution
            v-if="b2cDeliverOrderItems && b2cDeliverOrderItems.length > 0"
            :distributionData="b2cDeliverOrderItems"
            :baseInfo="dataBaseInfo"
        ></compDistribution>
        <!-- 关联 -->
        <compRelation
            v-if="type == 'query' && dataRelation != ''"
            :comreleVance="dataRelation"
            :nodeId="nodeid"
        ></compRelation>
        <!-- 收货 -->
        <compReceive
            v-if="b2cOrderInfo"
            :alltype="type"
            :comReceive="dataReceive"
            ref="refrevice"
            :class="{ b2corder: type == 'query' }"
        ></compReceive>
        <!-- 产品 -->
        <compProducts
            :alltype="type"
            :comProduct="dataProducts"
            :orgId="alldatas.contextId"
            :channelFlag="dataBaseInfo.channelFlag"
            ref="refproduct"
            :fulfillmentChannel="dataBaseInfo.fulfillmentChannel"
            :isInsurance="isInsurance"
        ></compProducts>
        <!-- 仓库 -->
        <compLogistics
            :class="{ b2corder: type == 'query' }"
            :alltype="type"
            :comLogistics="dataLogistics"
            :parentId="id"
            ref="refwarehouse"
            v-on:isInsuranceChange="isInsuranceChange"
        ></compLogistics>
        <!-- 包裹 -->
        <compPackages
            v-if="type == 'query' && dataPackages != ''"
            :comPackages="dataPackages"
        ></compPackages>
        <!-- 附件 -->
        <compEnclosure
            v-if="type == 'query' && dataEnclosure != ''"
            :comEnclosure="dataEnclosure"
            :parentId="id"
            @on-update="getDetail()"
        ></compEnclosure>
        <!-- 产品序列号 -->
        <compSerial 
        :orderid="id"></compSerial>
        
        <!-- 订单日志 -->
        <compOrderlog
            v-if="type == 'query'"
            :comOrderlog="dataOrderlog"
        ></compOrderlog>

        <footer class="bg-fff padding-20 text-right" v-if="type !== 'query'">
            <Button
                type="primary"
                class="width-10per margin-right-10"
                @click="submit(true)"
                >{{
                    $t("global.common.update_submit", { defaultValue: "提交" })
                }}</Button
            >
            <Button class="width-10per" @click="cancel">{{
                $t("global.common.operation_cancel", { defaultValue: "取消" })
            }}</Button>
        </footer>

        <!-- 重置订单，项目手动，恢复弹框 -->
        <Modal
            v-model="operate.show"
            :mask-closable="false"
            width="450"
            @on-cancel="close('all')"
            @on-refresh="getDetail"
        >
            <div class="headercss">
                <p>{{ operate.title }}</p>
            </div>
            <div style="text-align: center; margin-top: 15px">
                <p v-html="operate.content"></p>
            </div>
            <div slot="footer">
                <Button
                    type="error"
                    size="large"
                    :loading="showDel"
                    long
                    @click="oksubmit"
                    >{{
                        $t("global.common.update_OK", { defaultValue: "确定" })
                    }}</Button
                >
            </div>
        </Modal>
        <!-- 添加备注、手动回传、附件上传 -->
        <Modal
            class="hidefooter"
            v-model="handle.show"
            :mask-closable="false"
            v-bind="handle"
        >
            <component
                :is="handle.component"
                @on-close="handleclose"
                @on-update="getDetail"
                v-bind="handle"
            ></component>
            <footer slot="footer" v-show="handle.footer"></footer>
        </Modal>
        <Spin size="large" fix v-if="loading"></Spin>
    </div>
</template>

<script>
import { mapState } from "vuex";
import operateMixin from "../list/operateMixin";
// 各个子组件
import compBase from "./base";
import compRelation from "./relation";
import compReceive from "./receiving";
import compProducts from "./products";
import compLogistics from "./logistics";
import compPackages from "./packages";
import compEnclosure from "./enclosure";
import compOrderlog from "./orderlog";
import compDistribution from "./distribution";
import comActiveOrder from "../alert/activeorder";
// 添加备注、手动回传、附件上传
import comAddnotes from "../alert/addnotes";
import comManualback from "../alert/manualback";
import comForcemanualback from "../alert/forcemanualback";
import comAttacheupload from "../alert/attachementupload";
import comPassprove from "../alert/passprove";

// 请求的http
import {
    HttpqueryB2COrder,
    HttpSaveOne,
    HttpResetOrder,
    HttpRecoveryNormal,
    HttpAddRemark,
    HttpResubmit,
    HttpB2cDisassembly,
    HttpGetAllLabel,
    HttpOrderAddLabel,
    HttpOrderRemoveLabel
} from "@/service/boss/b2corder";
import compSerial from './compSerial.vue'
// import compSendTime from '../alert/sendtime'
import { constants } from "os";
import { request } from "http";
export default {
    name: "comIndex",
    props: ["activeids", "querytype"],
    mixins: [operateMixin],
    components: {
        compBase,
        compRelation,
        compReceive,
        compProducts,
        compLogistics,
        compPackages,
        compEnclosure,
        compOrderlog,
        compDistribution,

        comAddnotes,
        comManualback,
        comForcemanualback,
        comAttacheupload,
        comPassprove,
        comActiveOrder,
        compSerial,
        // compSendTime
    },
    data() {
        return {
            SYSID: "",
            showSubmit: false,
            loading: false,
            type: this.$route.params.type,
            id: this.$route.query.id,
            showDel: false,
            //issuper: this.$route.query.issuper == 1,
            nodeid: 0,
            status: "",
            baseData: {},
            title: {
                add: this.$t("global.common.operation_add", {
                    defaultValue: "新增",
                }),
                edit: this.$t("global.common.operation_edit", {
                    defaultValue: "编辑",
                }),
                query: this.$t("global.common.operation_see", {
                    defaultValue: "查看",
                }),
            },
            progressStatus: [
                {
                    value: "pending",
                    name: this.$t("erp.b2c.orderstatus_pending", {
                        defaultValue: "未支付",
                    }),
                },
                {
                    value: "unshipped",
                    name: this.$t("erp.b2c.orderstatus_unshipped", {
                        defaultValue: "未发货",
                    }),
                },
                {
                    value: "approved",
                    name: this.$t("erp.b2c.orderstatus_approved", {
                        defaultValue: "已审核",
                    }),
                },
                // {
                //     value: "assigned",
                //     name: this.$t("erp.b2c.orderstatus_assigned", {
                //         defaultValue: "已分配",
                //     }),
                // },
                {
                    value: "picked",
                    name: this.$t("erp.b2c.orderstatus_picked", {
                        defaultValue: "已配货",
                    }),
                },
                {
                    value: "shipped",
                    name: this.$t("erp.b2c.orderstatus_shipped", {
                        defaultValue: "已发货",
                    }),
                },
                {
                    value: "canceled",
                    name: this.$t("erp.b2c.orderstatus_canceled", {
                        defaultValue: "已取消",
                    }),
                },
            ],
            // 几个模块
            alldatas: "",
            dataBaseInfo: {},
            dataRelation: [],
            dataReceive: {},
            dataProducts: [],
            dataLogistics: {},
            dataPackages: [],
            dataEnclosure: [],
            dataOrderlog: [],
            b2cDeliverOrderItems: [],

            operate: {
                // loading:true,
                show: false,
                title: "",
                content: "",
                oktext: this.$t("global.common.update_OK", {
                    defaultValue: "确定",
                }),
                canceltext: this.$t("global.common.operation_cancel", {
                    defaultValue: "取消",
                }),
            },

            statusIndex: 0,
            // 设置几个弹框的变量
            handle: {
                show: false,
                title: "",
                component: null,
            },
            isInsurance: false,
            labelList: [],
            selectedList: []
        };
    },
    created() {
        this.getDetail();
        this.b2cOrderInfo = this.handleAuth("erp.b2cOrder.address");
        this.b2cOrderset = this.handleAuth('erp.b2cOrder.set');
        this.b2cOrderresubmit = this.handleAuth('erp.b2cOrder.reSubmit');
    },
    watch: {
        $route: function (to, from) {
            // console.log(to,from)
            // console.log(this.type)
            this.id = this.$route.query.id;
            if (this.type == "query") {
                this.getDetail();
            }
        },
    },
    methods: {
        refresh () {
            this.getDetail();
            this.$refs.refwarehouse.getCalData();
        },
        handleLabelChange (selected) {
             HttpOrderAddLabel({
                labelIds: selected.join(','),
                orderIds: this.dataBaseInfo.orderId,
                singleFlag: 1
            }).then(res => {
                this.getDetail();
                this.$emit('on-update');
            }, err => {
                this.$VMessage.error(err.message);
            });
            // // 添加
            // let promiseA = new Promise((resolve, reject) => {
            //     if (!selected.length) return resolve();
            //     HttpOrderAddLabel({
            //         labelIds: selected.join(','),
            //         orderIds: this.dataBaseInfo.orderId,
            //         singleFlag: 1
            //     }).then(res => {
            //         resolve(res);
            //     }, err => {
            //         reject(err);
            //     });
            // });
            // let promiseB = new Promise((resolve, reject) => {
            //     if (!unSelected.length) return resolve();
            //     // 移除
            //     HttpOrderRemoveLabel({
            //         labelIds: unSelected.join(','),
            //         orderIds: this.dataBaseInfo.orderId
            //     }).then(res => {
            //         resolve(res);
            //     }, err => {
            //         reject(err);
            //     });
            // })
            // Promise.all([promiseA, promiseB]).then(res => {
            //     // this.$VMessage.success(res[0].message);
            //     // this.$nextTick(() => {
            //         // this.$refs.compsearch.formData['IN_orderLabelEntities.labelId'] = '';
            //         this.getDetail();
            //         this.$emit('on-update');
            //         // this.updateSearch();
            //     // });
            // }, err => {
            //     console.log(err);
            //     this.$VMessage.error(err.message);
            // });
        },
        async getLabelData () {
            await HttpGetAllLabel({
                module: 26
            }).then(res => {
                this.labelList = res.data;
            }, err => {
                this.$VMessage.error(err.message);
            });
            let labelList = [];
            let baseData = this.dataBaseInfo;
            if (!baseData.labelIds || !baseData.labelIds.length) return this.selectedList = [];
            baseData.labelIds.forEach(labelId => {
                this.labelList.map(item => {
                    if (labelId === item.labelId) {
                        labelList.push({
                            ...item
                        });
                    }
                });
            });
            this.selectedList = labelList;
        },
        isInsuranceChange(value) {
            this.isInsurance = value;
        },
        openloading() {
            // console.log(123123123)
            this.loading = true;
        },
        closeloading() {
            this.loading = false;
        },
        getDetail() {
            if (this.activeids) {
                this.id = this.activeids;
                this.type = this.querytype;
            } else {
                this.id = this.id;
                this.type = this.type;
            }
            this.loading = true;
            return HttpqueryB2COrder({
                orderId: this.id,
            }).then(
                (res) => {
                    this.handleResponse(res.data);
                    this.nodeid = res.data.nodeId;
                    this.alldatas = res.data;
                    sessionStorage.set("alldatas", JSON.stringify(res.data));
                    this.SYSID = global.SYSID;
                    this.loading = false;
                },
                (err) => {
                    this.loading = false;
                    this.$Message.error({
                        content: err.message,
                        duration: 10,
                        closable: true,
                    });
                }
            );
        },
        handleOperate(val) {
            this.operate = {};
            switch (val) {
                case "reset":
                    this.operate.title = this.$t("erp.b2c.reset_order", {
                        defaultValue: "重置订单",
                    });
                    this.operate = {
                        show: true,
                        title: this.$t("erp.b2c.reset_order", {
                            defaultValue: "重置订单",
                        }),
                        content: this.$t("erp.b2c.resetorder_desc", {
                            defaultValue:
                                "订单重置后会恢复初始状态，并变为手工订单，是否确认提交？",
                        }),
                        type: val,
                    };

                    break;
                case "project":
                    this.operate = {
                        show: true,
                        title: this.$t("erp.b2c.project_manual", {
                            defaultValue: "项目手动关联",
                        }),
                        content: this.$t("erp.b2c.projectmanual_desc", {
                            defaultValue:
                                "确定手动关联项目？请先确认渠道产品已经添加",
                        }),
                        type: val,
                    };

                    break;
                case "addproduct":
                    const url = this.$router.resolve({
                        path: "/home/b2corder/addgistlist/edit",
                        query: { id: this.id },
                    });
                    window.open(url.href, "_blank");
                    break;
                case "addnotes":
                    this.handle = {
                        title: this.$t("erp.b2c.add_notes", {
                            defaultValue: "添加备注",
                        }),
                        show: true,
                        activeids: this.id,
                        width: 600,
                        component: "comAddnotes",
                    };
                    break;

                case "manualback":
                    this.handle = {
                        title: this.$t("erp.b2c.manual_back", {
                            defaultValue: "手动回传",
                        }),
                        show: true,
                        activeids: this.id,
                        nodeid: this.nodeid,
                        width: 1100,
                        component: "comManualback",
                    };
                    break;
                case "forcemanualback":
                    this.handle = {
                        title: this.$t("erp.b2c.mandatorymanual_back", {
                            defaultValue: "强制手动回传",
                        }),
                        show: true,
                        activeids: this.id,
                        nodeid: this.nodeid,
                        orgId: this.SYSID,
                        warehouseid: this.dataLogistics.orgWarehouseId,
                        width: 1100,
                        component: "comForcemanualback",
                    };
                    break;

                case "attacheupload":
                    this.handle = {
                        title: this.$t("erp.b2c.arrachement_upload", {
                            defaultValue: "附件上传",
                        }),
                        show: true,
                        activeids: this.id,
                        orderStatus: this.dataBaseInfo.orderStatus,
                        width: 1000,
                        component: "comAttacheupload",
                    };
                    break;
                case "normal":
                    this.operate.title = this.$t("erp.b2c.back_normal", {
                        defaultValue: "恢复正常",
                    });
                    this.operate = {
                        show: true,
                        title: this.$t("erp.b2c.back_normal", {
                            defaultValue: "恢复正常",
                        }),
                        content: this.$t("erp.b2c.backnormal_desc", {
                            defaultValue: "确定要将订单恢复为正常处理的订单？",
                        }),
                        type: val,
                    };
                    break;
                case "removeexcept":
                    this.operate.title = this.$t(
                        "erp.b2c.back_normal_onlyremove",
                        { defaultValue: "恢复正常 (仅去除异常)" }
                    );
                    this.operate = {
                        show: true,
                        title: this.$t("erp.b2c.back_normal_onlyremove", {
                            defaultValue: "恢复正常 (仅去除异常)",
                        }),
                        content: this.$t("erp.b2c.backnormal_onlyremovedesc", {
                            defaultValue:
                                "该操作仅去除订单的异常类型，不会进入订单自动处理流程",
                        }),
                        type: val,
                    };

                    break;
                case "resubmit":
                    this.operate = {
                        show: true,
                        title: this.$t("global.common.resubmit", {
                            defaultValue: "重新提交",
                        }),
                        content: this.$t("global.common.resubmit_desc", {
                            defaultValue:
                                "重新提交后，系统会重新自动处理当前订单",
                        }),
                        type: val,
                    };

                    break;
                case "orderDistributionDisassembly":
                    this.operate = {
                        show: true,
                        title: this.$t("erp.b2c.one_click_split_order", {
                            defaultValue: "一键拆单",
                        }),
                        content: this.$t("erp.b2c.one_click_split_order_text", {
                            defaultValue: `<div style='text-align: left'>注意：</br>1.一键拆单规则：订单优先级仓库中，按照优先级从高到低、同优先级距离从近到远的顺序检查虚拟库存，满足库存的按仓库拆成一个子订单，直到所有ERP SKU拆分完成或者所有仓库都检查完成（所有仓库都没库存的ERP SKU会拆成一个子订单）；</br>2.拆解后的子订单都是待激活订单，确认后需要手动激活订单。</div>`,
                        }),
                        type: val,
                    };
                    break;
                case "edit":
                    this.handle = {
                        title: this.$t("global.common.operation_edit", {
                            defaultValue: "编辑",
                        }),
                        show: true,
                        width: 1200,
                        component: "comIndex",
                        activeids: this.id,
                        querytype: "edit",
                    };
                    break;
                case "passapprove":
                    this.handle = {
                        title: this.$t("erp.b2c.approved", {
                            defaultValue: "审核通过",
                        }),
                        show: true,
                        width: 600,
                        component: "comPassprove",
                        activeids: this.id,
                    };
                    break;
                case "activeorder":
                    this.handle = {
                        title: this.$t("erp.b2c.active_order", {
                            defaultValue: "激活订单",
                        }),
                        show: true,
                        width: 600,
                        component: "comActiveOrder",
                        activeids: this.id,
                    };
                    break;
            }
        },
        handleModal(type) {
            if (!type) return;
            console.log(type);
            let { component, props, handleFunc, title, desc } = {
                ...this.getOperateRequestMap(type, this.id),
            };
            console.log(component, props);
            if (desc) {
                this.operate = {
                    show: true,
                    title: title,
                    content: desc,
                    type: type,
                };
            } else if (component) {
                console.log(component);
                this.handle = {
                    show: true,
                    title: title,
                    component: component,
                    ...props,
                };
            } else {
                handleFunc();
            }
        },
        oksubmit() {
            let request,
                params = {},
                { type } = this.operate;
            let orderIds = [];
            orderIds.push(this.id);
            switch (type) {
                case "reset":
                    request = HttpResetOrder;
                    params = { orderIds };
                    break;
                case "project":
                    // request = HttpRecoveryNormal;
                    // params = { id }
                    break;
                case "normal":
                    request = HttpRecoveryNormal;
                    params = { orderIds: orderIds, recoveryNormal: 1 };
                    break;
                case "removeexcept":
                    request = HttpRecoveryNormal;
                    params = { orderIds: orderIds, recoveryNormal: 0 };
                    break;
                case "resubmit":
                    request = HttpResubmit;
                    params = { orderIds };
                    break;
                case "orderDistributionDisassembly":
                    request = HttpB2cDisassembly;
                    params = { orderId: orderIds };
                    break;
            }
            if (!request) {
                let item = this.getOperateRequestMap(type, orderIds);
                request = item.request;
                params = item.params;
            }

            this.showDel = true;
            request(params)
                .then((res) => {
                    this.operate.show = false;
                    this.$Message.success({
                        content: res.message,
                        duration: 10,
                        closable: true,
                    });
                    // 重新进行请求
                    this.getDetail();
                    this.showDel = false;
                })
                .catch((err) => {
                    this.$Message.error({
                        content: err.message,
                        duration: 10,
                        closable: true,
                    });
                    this.showDel = false;
                });
        },
        close(val) {
            this.$emit("on-openCloseable");
            switch (val) {
                case "all":
                    this.operate.show = false;
                    break;
            }
            // this.$emit('on-close')
        },
        handleclose() {
            this.$emit("on-openCloseable");
            this.handle = {};
        },
        handleResponse(data) {
            // 模块的赋值
            this.$set(this.$data, "dataBaseInfo", data.baseInfo || {});
            this.$set(this.$data, "dataRelation", data.relation || []);
            this.$set(this.$data, "dataReceive", data.receive || {});
            this.$set(this.$data, "dataProducts", data.products || []);
            this.$set(this.$data, "dataLogistics", data.logistics || {});
            this.$set(this.$data, "dataPackages", data.packages || []);
            this.$set(this.$data, "dataEnclosure", data.enclosure || []);
            this.$set(this.$data, "dataOrderlog", data.orderLog || []);
            this.$set(
                this.$data,
                "b2cDeliverOrderItems",
                data.b2cDeliverOrderItems || []
            );
            this.getLabelData();

            const orderStatus = data.relation.orderStatus;
            let status = data.baseInfo.orderStatus;
            this.statusIndex = this.progressStatus.findIndex((item) => {
                return item.value === status;
            });
            if (orderStatus === "refunded") {
                this.progressStatus = [
                    {
                        value: "refunded",
                        name: this.$t("erp.b2c.orderstatus_refunded", {
                            defaultValue: "已退款",
                        }),
                    },
                ];
            } else if (orderStatus === "canceled") {
                this.progressStatus = [
                    {
                        value: "canceled",
                        name: this.$t("erp.b2c.orderstatus_canceled", {
                            defaultValue: "已取消",
                        }),
                    },
                ];
            }
        },
        submit() {
            let refbase = this.$refs.refbase;
            let refrevice = this.$refs.refrevice;
            let refproduct = this.$refs.refproduct;
            let refwarehouse = this.$refs.refwarehouse;
            let flag = false;
            // console.log(refrevice.formData)
            for (var key in refrevice.formData) {
                if (
                    refrevice.formData["addressline"] == "" ||
                    refrevice.formData["city"] == "" ||
                    refrevice.formData["countryCode"] == "" ||
                    refrevice.formData["postalCode"] == "" ||
                    !refrevice.formData["shippingName"]
                ) {
                    flag = true;
                }
            }
            for (var key in refwarehouse.formData) {
                if (
                    !refwarehouse.formData["orgWarehouseCode"] ||
                    !refwarehouse.formData["shippingMethodCode"]
                ) {
                    flag = true;
                }
            }

            if (flag) {
                this.$Message.error(
                    this.$t("global.common.warning_empty", {
                        defaultValue: "带*的数值不能为空",
                    })
                );
            } else {
                this.loading = true;
                HttpSaveOne({
                    baseInfo: refbase.combaseInfo,
                    receive: refrevice.formData,
                    products: refproduct.productList,
                    logistics: refwarehouse.formData,
                })
                    .then(
                        (res) => {
                            this.$Message.success({
                                content: res.message,
                                duration: 10,
                                closable: true,
                            });

                            if (this.querytype == "edit") {
                                this.$emit("on-update");
                                this.$emit("on-close");
                            } else {
                                this.type = "query";
                                this.$router.push({
                                    // name: "b2cOrder"
                                    name: "b2cOrderupdate",
                                    params: { type: "query" },
                                    query: { id: this.id },
                                });
                            }
                        },
                        (err) => {
                            this.$Message.error({
                                content: err.message,
                                duration: 10,
                                closable: true,
                            });
                        }
                    )
                    .finally(() => {
                        this.loading = false;
                    });
            }
        },
        cancel() {
            if (this.querytype == "edit") {
                this.$emit("on-close");
            } else {
                this.$router.push({
                    name: "b2cOrder",
                });
            }
        },
        filterCode(val) {
            let errorcode;
            switch (val) {
                case "insufficientInventoryException":
                    errorcode = this.$t(
                        "erp.b2c.errorcode_insufficientInventoryException",
                        { defaultValue: "库存不足" }
                    );
                    break;
                case "deliverOrderCancelException":
                    errorcode = this.$t(
                        "erp.b2c.errorcode_deliverOrderCancelException",
                        { defaultValue: "配货单取消异常" }
                    );
                    break;
                case "unexception":
                    errorcode = this.$t("erp.b2c.errorcode_unexception", {
                        defaultValue: "无异常的订单",
                    });
                    break;
                case "systemException":
                    errorcode = this.$t("erp.b2c.errorcode_systemException", {
                        defaultValue: "系统异常",
                    });
                    break;
                case "configurationException":
                    errorcode = this.$t("erp.b2c.configuration_exception", {
                        defaultValue: " 配置异常",
                    });
                    break;
                case "produceException":
                    errorcode = this.$t("erp.b2c.errorcode_produceException", {
                        defaultValue: "商品无法关联",
                    });
                    break;
                case "addressException":
                    errorcode = this.$t("erp.b2c.errorcode_addressException", {
                        defaultValue: "订单地址异常",
                    });
                    break;
                case "updateException":
                    errorcode = this.$t("erp.b2c.errorcode_updateException", {
                        defaultValue: "订单更新异常",
                    });
                    break;
                case "pickingException":
                    errorcode = this.$t("erp.b2c.errorcode_pickingException", {
                        defaultValue: "订单配货异常",
                    });
                    break;
                case "cancelException":
                    errorcode = this.$t("erp.b2c.errorcode_cancelException", {
                        defaultValue: "订单取消异常",
                    });
                    break;
                case "trackingException":
                    errorcode = this.$t("erp.b2c.errorcode_trackingException", {
                        defaultValue: "Tracking异常",
                    });
                    break;
                case "costException":
                    errorcode = this.$t("erp.b2c.errorcode_costException", {
                        defaultValue: "订单成本异常",
                    });
                    break;
                case "carrierException":
                    errorcode = this.$t("erp.b2c.errorcode_carrierException", {
                        defaultValue: "订单发运方式异常",
                    });
                    break;
                case "uploadException":
                    errorcode = this.$t("erp.b2c.errorcode_uploadException", {
                        defaultValue: "订单附件上传异常",
                    });
                    break;
                case "purchaseException":
                    errorcode = "购买面单异常";
                    break;
                // case 'purchaseException': errorcode = '购买异常'; break;
            }
            return errorcode;
        },
    },
    beforeDestroy() {},
};
</script>